import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import type {
  TypeApiResponse,
  TypePostReceivingRequestParams,
  TypePostReceivingRequestResponse,
} from '~/types/receive.types';

type TypePostReceivingRequestMutationParams = {
  ownerCode: string;
  params: TypePostReceivingRequestParams;
};

const fetchPostReceivingRequest = async ({
  ownerCode,
  params,
}: TypePostReceivingRequestMutationParams): Promise<TypePostReceivingRequestResponse> => {
  const { data } = await axiosInstance.post<TypeApiResponse<TypePostReceivingRequestResponse>>(
    `/api-inbound/v1/3pl/receiving/${ownerCode}/request`,
    params
  );

  return data.data;
};

/**
 * [입고관리 > 입고요청관리] 입고요청등록 모달 > 입고 요청 Mutation Hook
 */
export const usePostReceivingRequestMutation = () => {
  return useMutation({
    mutationFn: fetchPostReceivingRequest,
  });
};
